"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Topsites_Preview = void 0;

Topsites_Preview = function () {
    function Topsites_Preview() {
        if (window.navigator && window.navigator.loadPurpose === "preview") {
            window.location.href = window.location.origin + "/topsites-preview/";
        }
    }

    return Topsites_Preview;
}();

exports.default = new Topsites_Preview();